import type { PrefillReviewResponse } from '@client/api/waterlily';

export type PrefillStep = 'review' | 'notice' | 'form';

interface ResolvePrefillStepArgs {
  review: PrefillReviewResponse | undefined;
  /** True once the client has continued past a prefill screen in this session. */
  reviewAcknowledged: boolean;
}

export function resolvePrefillStep({
  review,
  reviewAcknowledged,
}: ResolvePrefillStepArgs): PrefillStep {
  if (!review?.hasPrefill || reviewAcknowledged) return 'form';
  return review.hasCompletedPrefillReview ? 'notice' : 'review';
}
